import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";
import { ActionCreatorWithoutPayload, ActionCreatorWithPayload, createAction } from "@reduxjs/toolkit";

const handleFetchArchiveChats: ActionCreatorWithPayload<ChatWithShortInfo[]> = createAction("archive/handleFetch");

const handleFetchArchiveChatsFailed: ActionCreatorWithoutPayload = createAction<void>("archive/handleFetchFailed");

const handleSwitchToArchiveFolder: ActionCreatorWithPayload<boolean> = createAction("archive/switchToFolder");

export default { handleFetchArchiveChats, handleFetchArchiveChatsFailed, handleSwitchToArchiveFolder };
